var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('NavTop'),_c('h1',{staticClass:"title__line__orange"},[_vm._v("dashboard")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }